import React, { useState, useEffect } from "react";
import "./SurveyModal.css";
import Modal from "react-bootstrap/Modal";
import { submitSurvey } from "../../api"

import Loading from "../../components/ui/loading";

import CloseIcon from "../../assets/survey/Close.svg";
import arrownext from "../../assets/survey/arrownext.svg";

import { getAllSurvey } from "../../actions/survey";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { toastifyMessage } from '../../handlers/toastifyMessage';
import EmoticonsView from "./SurveyEmoticonsView";
import TextView from "./SurveyTextView";

import MultiSelect from './SurveyMultiSelectView'
import SelectAndText from "./SurveySelectAndText";
import SurveyThankYouScreen from "./SurveyThankYouScreen";

function SurveyModal(props) {
  const { t } = useTranslation();
  const [view, setView] = useState('before_api_call') // to handle before and after api calls view
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const queryParamsValue = searchParams.get("queryParams");
  let lng = JSON.parse(localStorage.getItem("language"))?.lang;
  const isEng = lng === 'en' || lng === 'eng'
  const dispatch = useDispatch()
  const surveyData = useSelector((state) => state.survey_fetch.allSurveys);
  const loading = useSelector((state) => state.survey_fetch.loading);
  const error = useSelector((state) => state.survey_fetch.error);
  const userDetails = JSON.parse(localStorage.getItem("userLogin"))?.Results?.[0];

  const [userResponses, setUserResponses] = useState([]);

  // api to get survey questions
  useEffect(() => {
    dispatch(getAllSurvey('89', '2025'));
  }, [dispatch])

  // for mobile view in erc mobile app
  useEffect(() => {
    if (queryParamsValue === 'false') {
      closeModal()
    }
  }, [])

  const closeModal = () => {
    props.onHide();
  };

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  // Normalize the answers for API submission
  const normalizeAnswersForApi = (responses) => {
    console.log(responses, "responses in normalizeAnswersForApi")
    const answers = {};
    responses?.forEach(({ QuestionID, AnswerType, answerValue, AnswerValue }) => {
      const qID = String(QuestionID);
      if (!answers[qID]) answers[qID] = [];

      // Emoticon (1)
      if (AnswerType === 1) {
        answers[qID].push({
          SELECT_ID: AnswerValue?.SelectID,
          ANSWER_CONTENT: null
        });

        // Text (2)
      }
      else
        if (AnswerType === 2) {
          answers[qID].push({
            SELECT_ID: null,
            ANSWER_CONTENT: AnswerValue
          });

          // Select + Text (3)
        } else if (AnswerType === 3) {
          answers[qID].push({
            SELECT_ID: AnswerValue?.selectedOption?.[0]?.SelectID ?? null,
            ANSWER_CONTENT:
              AnswerValue?.text
          });

          // Multi-select (4)
        } else if (AnswerType === 4 && Array.isArray(AnswerValue)) {
          AnswerValue.forEach((item) => {
            answers[qID].push({
              SELECT_ID: item.SelectID ?? null,
              ANSWER_CONTENT: null
            });
          });
        }
    });

    return { Answers: answers };
  };

  const submitSurveyAnswers = async () => {

    //<---------------------------- To check if all required fields are filled----------------------------->
    //Currently only emoticon questions are required
    const checkHowManyEmoticonQuestions = surveyData?.filter((item) => item.AnswerType === 1)?.length;

    const areRequiredEmoticonsNotSelected = checkHowManyEmoticonQuestions > userResponses?.length

    if (areRequiredEmoticonsNotSelected) {
      toastifyMessage(t("Please select an emoticon for all required questions."), undefined, 'error');
      return; // Stop the API call
    }

    //<---------------------------- To check if all required fields are filled----------------------------->

    const payload = normalizeAnswersForApi(userResponses);

    const updatedPayload = {
      "SurveyID": 89,
      "SurveyYear": 2025,
      "INVOICE_NO": (props.payloadExtras?.invoice) ?? null,
      "APPLICATION": "WEBAPP",
      "COURSE_ID": null,
      "COURSE_YEAR": null,
      "EMAIL": userDetails?.email ?? null,
      "VLNT_ID": userDetails?.vln_id ?? null,
      "PERSON_ID": userDetails?.person_id ?? null,
      ...payload
    }

    try {
      var response = await submitSurvey(updatedPayload);

      if (response?.data) {
        toastifyMessage(response?.data?.Result ?? "Success", undefined, 'success');
        setView('after_api_call')
        // closeModal()
      }
      return response.data;
    } catch (error) {
      toastifyMessage(error?.message ?? "Error", undefined, 'error');
      console.error('Error submitting survey:', error);
      throw error;
    }
  };

  const saveAnswer = (questionID, answerType, answerValue) => {
    setUserResponses((prev) => {
      const updated = prev.filter((item) => item.QuestionID !== questionID);
      return [...updated, { QuestionID: questionID, AnswerType: answerType, AnswerValue: answerValue }];
    });
  };


  const renderContinueButton = (
    <div className="survey_common_style_center survey_full_width">
      <div className="survey_modal_bottom">
        <button onClick={() => submitSurveyAnswers()} className="survey_moveOn_btn">
          <div style={lng === "arab" ? { direction: "rtl" } : null}>{t("Continue")}</div>
        </button>
        <img style={{ position: 'absolute', top: 15, right: 10, transform: lng === "arab" ? 'rotate(180deg)' : undefined }} src={arrownext} alt="arrow_next" />
      </div>
    </div>
  )

  const renderSkip = (
    <div className="survey_common_style_center survey_full_width">
      <div className="survey_skip_button">
        <u style={lng === "arab" ? { direction: "rtl" } : null} onClick={() => closeModal()} className="survey_skip_button">{t("Skip")}</u>
      </div>
    </div>
  )

  const renderBorder = () => {
    return (
      <div className="survey_border"></div>
    )
  }


  const renderProgressTabs = () => (
    <>
      <div className="header_survey" style={{ fontFamily: 'Poppins' }}>{!isEng ? surveyData?.[0]?.SurveyTitleA : surveyData?.[0]?.SurveyTitleE}</div>
      <div className="current_survey_step">&nbsp;</div>

    </>
  )

  const renderLoading = () => (
    <Loading
      height={width <= 1920 ? "300px" : "400px"}
      mediaQ="300px"
    />
  )

  const renderSurvey = () => {

    return surveyData?.map((item, index) => {
      const isSingleSelect = item?.AnswerType === 1;
      const isText = item?.AnswerType === 2;
      const isSelectText = item?.AnswerType === 3;
      const isMultiSelect = item?.AnswerType === 4;

      const title = isEng ? item?.TitleE : item?.TitleA;

      const content = (() => {
        if (isSingleSelect) return (
          <EmoticonsView title={title} question={item} saveAnswer={saveAnswer} isEng={isEng} />
        )
        if (isText) return (
          <TextView title={title} question={item} saveAnswer={saveAnswer}
            isEng={isEng} lng={lng} />
        );
        if (isSelectText) return (
          <SelectAndText title={title} options={item?.answers} question={item} saveAnswer={saveAnswer} lng={lng} isEng={isEng} />
        )

        if (isMultiSelect) return (
          <MultiSelect title={title} options={item?.answers} question={item} saveAnswer={saveAnswer} lng={lng} isEng={isEng} />
        )
        return null;
      })();

      return (
        <div key={index}>
          {content}
          {index !== surveyData.length - 1 && (
            renderBorder()
          )}
        </div>
      );
    });

  }
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="pop_up_container_forSurvey"
    >
      <img onClick={closeModal} className="survey_close_icon" src={CloseIcon} />
      <Modal.Body>


        {loading && renderLoading()}


        {/* View displayed before api call */}
        {(view === 'before_api_call' && !loading) && (
          <div
            className="survey_modal_slideOne"
          >
            {renderProgressTabs()}
            {renderSurvey()}
            {renderContinueButton}
            {renderSkip}
          </div>
        )}

        {error && <div>{error}</div>}

        {/* View displayed after api call */}
        {(view === 'after_api_call' && !loading) && (
          <div className="survey_modal_thankyou">
            <SurveyThankYouScreen closeModal={closeModal} />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
export default SurveyModal;
